import { Link } from "react-router-dom";
import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useMemo, useState, useRef, KeyboardEvent, ChangeEvent } from "react";
import VendorsPage from "pages/signage/VendorsPage";


const AgentSuppliers = () => {

  return (
    <>
      <VendorsPage user={`agent`} />
    </>
  );
};

export default AgentSuppliers;
